import React, {memo, useState} from 'react'
import {Handle, Position, NodeProps, type Node, type Edge} from 'reactflow'
import {getCSSVariableValue} from '../../../../../../../_metronic/assets/ts/_utils/DomHelpers'
import {useI18n} from '../../../../../../Utils/_helpers/useI18n'

export interface EndNodeProps extends NodeProps {
  pushToUndoStack?: (nodes: Node[], edges: Edge[]) => void
  isUndoRedoOperation?: React.MutableRefObject<boolean>
}

const EndNode: React.FC<EndNodeProps> = ({
  id,
  selected,
  data,
  pushToUndoStack,
  isUndoRedoOperation,
}) => {
  const isSelected = selected
  const [hovered, setHovered] = useState(false)
  const {t} = useI18n()

  const bgColor = getCSSVariableValue('--bs-gray-500')

  const isNotDeletable = data && (data as any).deletable === false
  return (
    <>
      <Handle type='target' position={Position.Top} id='end-top' className='bg-primary' />
      <div
        className={`px-3 box-shadow-sm py-1 rounded-pill text-center${
          isSelected || isNotDeletable ? ' border border-2 border-primary' : ''
        } flex items-center justify-center nopan${hovered ? ' node-hover' : ''}`}
        style={{
          backgroundColor: bgColor,
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        title={t('FLOW.NODE.END_DESC')}
      >
        <span className='text-dark' title={t('FLOW.NODE.END_DESC')}>
          End
        </span>
      </div>
    </>
  )
}

export default memo(EndNode)
